import { render, staticRenderFns } from "./BlackGoldSportsFrame.vue?vue&type=template&id=8f0756a6"
import script from "./BlackGoldSportsFrame.vue?vue&type=script&lang=js"
export * from "./BlackGoldSportsFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports